export default __webpack_public_path__ + "static/media/roads.62051159.png";